import { useSetState } from 'ahooks'
import { Image } from 'antd-mobile'
import { AddSquareOutline } from 'antd-mobile-icons'
import { isEmpty } from 'lodash-es'
import { toJS } from 'mobx'
import { observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect } from 'react'

import jobStore from '@/store/components/entryJob'

import getQuery from '@/utils/getQuery'

import { HBlockAdd } from '../../HYBVant'

import Popup from './Popup'

import './index.less'
import useIncomeTaxDeclaration from './useIncomeTaxDeclaration'

interface IIncomeTaxDeclaration {
  onConfirm?: (data: any) => void
  isLocalObserver?: boolean
  is_edite_user?: boolean
  disabled?: boolean
  positionId?: string | null
  value: any[]
}
const IncomeTaxDeclaration: React.FC<IIncomeTaxDeclaration> = ({
  onConfirm,
  isLocalObserver,
  is_edite_user: is_auth = false,
  disabled = true,
  positionId = null,
  // ...rest,
  value
}) => {
  // console.log('isLocalObserver--->>>', is_auth)
  const staffId = decodeURIComponent(getQuery('staffId') || '')
  const { employeeIds } = useLocalObservable(() => jobStore)
  const staff_Id = employeeIds?.[0] || staffId
  const isAuth: boolean = is_auth
  const [{ taxUserInfos, staffDetail }, setState] = useSetState<{
    taxUserInfos: any[]
    staffDetail: any
  }>({
    taxUserInfos: [],
    staffDetail: {}
  })
  const local = useIncomeTaxDeclaration({
    onConfirm,
    staffDetail,
    staff_Id,
    taxUserInfos,
    setState
  })
  const {
    add,
    edit,
    open,
    modalData,
    onCancel,
    runDeleteTaxUserInfos,
    runSaveTaxUserInfos,
    deleteTaxUserInfosLoading,
    saveTaxUserInfosLoading
  } = local
  console.log('taxUserInfos', toJS(taxUserInfos))
  return (
    <div className='health_certificate'>
      {!isEmpty(taxUserInfos) && (
        <div className='health_certificate-content-wrapper'>
          {taxUserInfos?.map((x: any, index: number) => (
            <div
              key={x}
              className='health_certificate-content'
              onClick={() => isAuth && edit(index)}
            >
              <div className='health_certificate-content-col-1'>
                <div className='health_certificate-content-1'>
                  {x?.office_name || '-'}
                  {x?.tax_calculation_method_name ? '(' + x?.tax_calculation_method_name + ')' : ''}
                </div>
                <div className='health_certificate-content-3'>
                  受雇日期：{x?.employment_date || '-'}
                </div>
              </div>
              <div className='health_certificate-content-col-2'>
                {isAuth && (
                  <Image
                    className='hyb-com-concat-content-col-2-img'
                    src='https://s.huiyunban.cn/1747191709529280512.png'
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {isAuth && <HBlockAdd onClick={add} text='添加个税申报信息' />}
      {open && (
        <Popup
          visible={open}
          onCancel={onCancel}
          modalData={{
            ...modalData,
            staffDetail,
            taxUserInfos,
            positionId,
            runDeleteTaxUserInfos,
            runSaveTaxUserInfos,
            deleteTaxUserInfosLoading,
            saveTaxUserInfosLoading
          }}
        />
      )}
    </div>
  )
}

export default observer(IncomeTaxDeclaration)
